import { CameraHelper, DirectionalLight, DirectionalLightHelper, Object3D } from "three"
import C from "../lib/Constants"

export default class Lights
{
    constructor(_options)
    {
        this.debug = _options.debug
        this.time = _options.time

        this.container = new Object3D()
        this.container.name = 'lights_container'

        this.setInstance()
        this.setShadows()
        this.setDebug()
    }

    setInstance()
    {
        this.instance = new DirectionalLight(0xffffff, 1)
        this.instance.position.copy(C.SCENE.lightPosition)
        this.container.add(this.instance)
    }

    setShadows()
    {
        this.instance.castShadow = true
        this.instance.shadow.normalBias = 0.006
        this.instance.shadow.radius = 2

        this.instance.shadow.camera.left   = - 2.00
        this.instance.shadow.camera.right  =   2.00
        this.instance.shadow.camera.top    =   1.10
        this.instance.shadow.camera.bottom = - 0.90
        this.instance.shadow.camera.near   =   0.01
        this.instance.shadow.camera.far    =   3.50

        this.instance.shadow.mapSize.setScalar(1024)
        this.instance.shadow.camera.updateProjectionMatrix()
    }

    setDebug()
    {
        if(this.debug.showLightShadowHelper)
        {
            this.shadowCamHelper = new CameraHelper(this.instance.shadow.camera)
            this.container.add(this.shadowCamHelper)
        }
        if(this.debug.showLightHelper)
        {
            this.lightHelper = new DirectionalLightHelper(this.instance, 1, 0xff00ff)
            this.container.add(this.lightHelper)
            this.time.on('tick', () =>
            {
                this.lightHelper.update()
            })
        }
    }
}